class SoundMock {
  static setCategory() {}
  static MAIN_BUNDLE = '';

  constructor(filename, basePathOrCb, cb) {
    const callback = typeof basePathOrCb === 'function' ? basePathOrCb : cb;
    try {
      let src = typeof filename === 'string' ? filename : (filename?.default || filename);
      if (typeof src === 'string' && !src.startsWith('/') && !src.startsWith('http') && !src.startsWith('blob:')) {
        src = '/' + src;
      }
      if (typeof Audio !== 'undefined' && src) {
        this.audio = new Audio(src);
        this.audio.addEventListener('loadedmetadata', () => {
          this.duration = this.audio?.duration || 0;
          this.isLoadedFlag = true;
          if (callback) callback(null);
        });
        this.audio.addEventListener('canplaythrough', () => {
          this.isLoadedFlag = true;
        });
        this.audio.addEventListener('error', (e) => {
          if (callback) callback(e);
        });
      } else {
        if (callback) callback(null);
      }
    } catch (err) {
      if (callback) callback(err);
    }
  }

  play(onEnd) {
    if (this.audio) {
      this.audio.currentTime = 0;
      this.audio.play().then(() => {
        if (onEnd) {
          this.audio.onended = () => onEnd(true);
        }
      }).catch((e) => {
        // Audio autoplay policy catch
        if (onEnd) onEnd(false);
      });
    } else if (onEnd) {
      onEnd(true);
    }
    return this;
  }

  stop(cb) {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
    if (cb) cb();
    return this;
  }

  pause(cb) {
    if (this.audio) this.audio.pause();
    if (cb) cb();
    return this;
  }

  setVolume(vol) {
    if (this.audio) this.audio.volume = Math.max(0, Math.min(1, vol));
    return this;
  }

  setNumberOfLoops(loops) {
    if (this.audio) this.audio.loop = loops === -1 || loops > 0;
    return this;
  }

  release() {
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  }

  isLoaded() {
    return !!this.isLoadedFlag;
  }

  isPlaying() {
    return this.audio ? !this.audio.paused && !this.audio.ended : false;
  }

  getDuration(cb) {
    if (cb) cb(this.duration || 0);
    return this.duration || 0;
  }
}

module.exports = SoundMock;
module.exports.default = SoundMock;
